module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/house-question-mark-cd47c20a55a58c05c342545c8ed3018f.svg";